import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const attendScoreRule = async (params: object) => {
  return await GET({ url: Api.attendScoreRule, params, showError: false })
}
